"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.includes.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _client = require("@apollo/client");

var _log = require("@meepshop/logger/lib/gqls/log");

var _pageError = require("@meepshop/page-error");

var _ErrorPageNotFound = _interopRequireDefault(require("./ErrorPageNotFound"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// definition
// eslint-disable-next-line react/prop-types
var _default = function _default(_ref) {
  var error = _ref.error;
  var client = (0, _client.useApolloClient)();
  var status = error.status;
  if (['ERROR_PAGE_NOT_FOUND', 'ERROR_PRODUCT_NOT_FOUND'].includes(status)) client.mutate({
    mutation: _log.log,
    variables: {
      input: {
        type: 'WARN',
        name: 'NOT_FOUND',
        data: error
      }
    }
  });
  if (status === 'ERROR_PAGE_NOT_FOUND') return /*#__PURE__*/_react["default"].createElement(_ErrorPageNotFound["default"], null);
  if (status === 'ERROR_PRODUCT_NOT_FOUND') return /*#__PURE__*/_react["default"].createElement(_ErrorPageNotFound["default"], null);
  if (status === 'API_ERROR') return /*#__PURE__*/_react["default"].createElement(_pageError.PageError, {
    error: _objectSpread(_objectSpread({}, error), {}, {
      networkError: {}
    })
  });
  return /*#__PURE__*/_react["default"].createElement(_pageError.PageError, {
    error: error
  });
};

exports["default"] = _default;